<template>
  <div class="qes-file-container">
    <FriedCard v-for="file of files" :key="file.id" class="qes-file-item">
      <FriedIcon icon="upload" />
      <FriedH4>{{ fileName(file) }}</FriedH4>
      <FriedIconButton
        v-if="isEditable"
        data-external="qes-file-delete-button"
        @click="$emit('delete', file.id)"
      >
        <FriedIcon icon="delete-bin" />
      </FriedIconButton>
      <FriedButton
        v-else
        :button-type="ButtonType.Tertiary"
        data-external="qes-file-download-button"
        @click="$emit('download', file.id)"
      >
        {{ t('download') }}
      </FriedButton>
    </FriedCard>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { ButtonType } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import type { DocumentQesFile } from '../types/document-qes-file';

export default defineComponent({
  props: {
    files: { type: Array as PropType<DocumentQesFile[]>, required: true },
    isEditable: { type: Boolean },
  },
  emits: ['delete', 'download'],
  setup() {
    const { t } = useI18n();
    const fileName = (file: DocumentQesFile) =>
      `${file.name || file.id}.${file.fileType.toLowerCase()}`;

    return { fileName, t, ButtonType };
  },
});
</script>

<style lang="scss" scoped>
.qes-file {
  &-container {
    margin: var(--spacing-200) 0;
  }

  &-item {
    padding: var(--spacing-200);
    display: grid;
    grid-template-columns: min-content auto min-content;
    align-items: center;
    gap: var(--spacing-50);
  }
}
</style>
